var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50018 10.5455L13.8081 7.47733L8.50018 4.40915V10.5455ZM20.3229 2.53756C20.4559 3.01824 20.5479 3.66255 20.6093 4.48074C20.6809 5.29892 20.7115 6.0046 20.7115 6.61824L20.7729 7.47733C20.7729 9.7171 20.6093 11.3637 20.3229 12.4171C20.0672 13.3376 19.474 13.9307 18.5536 14.1864C18.0729 14.3194 17.1934 14.4114 15.8434 14.4728C14.5138 14.5444 13.2968 14.5751 12.1718 14.5751L10.5456 14.6364C6.2604 14.6364 3.59109 14.4728 2.53768 14.1864C1.61722 13.9307 1.02404 13.3376 0.768359 12.4171C0.635405 11.9364 0.543359 11.2921 0.481996 10.4739C0.410405 9.65574 0.379723 8.95006 0.379723 8.33642L0.318359 7.47733C0.318359 5.23756 0.481996 3.59096 0.768359 2.53756C1.02404 1.6171 1.61722 1.02392 2.53768 0.768237C3.01836 0.635283 3.8979 0.543237 5.2479 0.481874C6.57745 0.410283 7.79449 0.379601 8.91949 0.379601L10.5456 0.318237C14.8309 0.318237 17.5002 0.481874 18.5536 0.768237C19.474 1.02392 20.0672 1.6171 20.3229 2.53756Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.4aa496c55df884e9d7d2546c56f29a84.svg";
export { ForwardRef as ReactComponent };